import { useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { SchoolSelect } from '../../components/common';
import { t, type MessageKey } from '../../i18n';
import { CatalogueTab } from './CatalogueTab';
import { CirculationTab } from './CirculationTab';
import { FinesTab } from './FinesTab';

type Tab = 'catalogue' | 'circulation' | 'fines';

export function LibraryPage() {
  const { can } = useAuth();
  const [schoolId, setSchoolId] = useState('');
  const [tab, setTab] = useState<Tab>('catalogue');
  const tabs: Tab[] = [];
  if (schoolId && can('library.view', schoolId)) tabs.push('catalogue');
  if (schoolId && can('library.view_loans', schoolId)) tabs.push('circulation', 'fines');
  const active = tabs.includes(tab) ? tab : tabs[0];

  return (
    <div className="mx-auto max-w-5xl space-y-4">
      <h1 className="text-2xl font-bold">{t('lib.title')}</h1>
      <SchoolSelect value={schoolId} onChange={setSchoolId} />
      {schoolId && active && (
        <>
          <div
            role="tablist"
            aria-label={t('lib.title')}
            className="flex flex-wrap gap-1 border-b border-slate-200"
          >
            {tabs.map((name) => (
              <button
                key={name}
                role="tab"
                type="button"
                aria-selected={active === name}
                onClick={() => setTab(name)}
                className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${active === name ? 'border-brand-700 text-brand-700' : 'border-transparent text-slate-600'}`}
              >
                {t(`lib.tab.${name}` as MessageKey)}
              </button>
            ))}
          </div>
          <div role="tabpanel">
            {active === 'catalogue' && <CatalogueTab schoolId={schoolId} />}
            {active === 'circulation' && <CirculationTab schoolId={schoolId} />}
            {active === 'fines' && <FinesTab schoolId={schoolId} />}
          </div>
        </>
      )}
    </div>
  );
}
